import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import LegalPageLayout from 'components/LegalPageLayout';
import { useI18n } from 'i18n/I18nContext';

const CookiesPage = () => {
  const { t } = useI18n();

  return (
    <LegalPageLayout title={t('cookies.title')}>
      <p className="mb-25">{t('cookies.intro')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('cookies.h1')}</h2>
      <p className="mb-25">{t('cookies.p1')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('cookies.h2')}</h2>
      <p className="mb-25">{t('cookies.essential')}</p>
      <p className="mb-25">{t('cookies.preferences')}</p>
      <p className="mb-25">{t('cookies.analytics')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('cookies.h3')}</h2>
      <p className="mb-25">{t('cookies.p3')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('cookies.h4')}</h2>
      <p className="mb-25">
        {t('cookies.p4Before')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/privacy">
          {t('footer.privacy')}
        </LocalizedLink>
        {t('cookies.p4After')}
      </p>
    </LegalPageLayout>
  );
};

export default CookiesPage;



// WEBPACK FOOTER //
// ./src/pages/CookiesPage.tsx